// Vendors
import { WebsocketClass } from '@openbank/cf-ui-framework';
// Utils
import { defaultMessageParser, getStringUrl, parseSentData } from '../utils/useWebSockets.utils';
import { WebSocketErrorEnum } from '../enumerations/websocket-error.enumeration';
const sendMessage = ({ webSocketRef, message, startTimer, onError, }) => {
    if (!webSocketRef.current) {
        onError?.(WebSocketErrorEnum.NOT_AVAILABLE);
        return;
    }
    webSocketRef.current.send(parseSentData(message));
    startTimer();
};
const disconnectWebSocket = async ({ webSocketRef, stopTimer, }) => {
    stopTimer();
    if (!webSocketRef.current) {
        return Promise.resolve();
    }
    const connectedWebsocket = webSocketRef.current;
    webSocketRef.current = null;
    await connectedWebsocket.disconnect();
};
const connectWebSocket = async ({ webSocketRef, onReceiveData, onError, stopTimer, setWebSocketConnected, refreshToken, url, }) => {
    if (webSocketRef.current) {
        return Promise.resolve();
    }
    // TODO: Improvement --> Deberíamos refrescar solamente si estamos cercano al tiempo de caducidad del token. Para un manejo más detallado, habría que verificar que siempre tengamos el mismo tiempo de token válido ó verificar si el error recibido en  el onError del websocket.listen (línea 78) es error de autenticación
    await refreshToken();
    webSocketRef.current = new WebsocketClass(getStringUrl(url), undefined, defaultMessageParser);
    webSocketRef.current.listen({
        onReceiveData(data) {
            stopTimer();
            // @ts-expect-error Forzamos type ya que WebsocketClass sólo permite string y nosotros permitimos cualquier tipo (usando defaultMessageParser)
            onReceiveData(data);
        },
        onError: () => {
            stopTimer();
            onError?.(WebSocketErrorEnum.CONNECTION);
        },
        onConnect() {
            setWebSocketConnected(true);
        },
        onDisconnect() {
            setWebSocketConnected(false);
        },
    });
    await webSocketRef.current.connect();
    await refreshToken();
};
const initializeSocket = async ({ initMessage, startTimer, webSocketRef, ...rest }) => {
    await connectWebSocket({ webSocketRef, ...rest });
    if (initMessage) {
        sendMessage({
            message: initMessage,
            webSocketRef,
            startTimer,
        });
    }
};
const WebsocketHandlers = ({ startTimer, stopTimer, webSocketRef, ...rest }) => ({
    webSocketSendMessage: message => sendMessage({ webSocketRef, message, startTimer }),
    webSocketDisconnect: () => disconnectWebSocket({ stopTimer, webSocketRef }),
    initializeSocketHandler: () => initializeSocket({
        webSocketRef,
        startTimer,
        stopTimer,
        ...rest,
    }),
});
export { WebsocketHandlers };
//# sourceMappingURL=useWebSocket.handlers.js.map